export enum CheckboxContainerType {
  AUCTION_PEN = "auction_pen",
  MLA = "mla",
}
